/**
 * @generated SignedSource<<c21c56307da90ea346af25f39d4f8d75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
export type OrgAdminCreateTeamMutation$variables = {
  color: string;
  icon: TeamIcon;
  isPrivate: boolean;
  storeIds: ReadonlyArray<string>;
  teamName: string;
  topicId?: string | null;
};
export type OrgAdminCreateTeamMutation$data = {
  readonly organisation: {
    readonly createTeams: {
      readonly id: string;
      readonly teams: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          };
        }>;
      } | null;
    } | null;
  };
};
export type OrgAdminCreateTeamMutation = {
  response: OrgAdminCreateTeamMutation$data;
  variables: OrgAdminCreateTeamMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "color"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "icon"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPrivate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storeIds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamName"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topicId"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "OrgMutation",
    "kind": "LinkedField",
    "name": "organisation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "color",
            "variableName": "color"
          },
          {
            "kind": "Variable",
            "name": "icon",
            "variableName": "icon"
          },
          {
            "kind": "Variable",
            "name": "isPrivate",
            "variableName": "isPrivate"
          },
          {
            "kind": "Variable",
            "name": "storeIds",
            "variableName": "storeIds"
          },
          {
            "kind": "Variable",
            "name": "teamName",
            "variableName": "teamName"
          },
          {
            "kind": "Variable",
            "name": "topicId",
            "variableName": "topicId"
          }
        ],
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "createTeams",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamConnection",
            "kind": "LinkedField",
            "name": "teams",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgAdminCreateTeamMutation",
    "selections": (v7/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "OrgAdminCreateTeamMutation",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "78430888f59554a09d8d45f72bc684df",
    "id": null,
    "metadata": {},
    "name": "OrgAdminCreateTeamMutation",
    "operationKind": "mutation",
    "text": "mutation OrgAdminCreateTeamMutation(\n  $storeIds: [ID!]!\n  $teamName: String!\n  $color: String!\n  $icon: TeamIcon!\n  $topicId: ID\n  $isPrivate: Boolean!\n) {\n  organisation {\n    createTeams(storeIds: $storeIds, teamName: $teamName, color: $color, icon: $icon, topicId: $topicId, isPrivate: $isPrivate) {\n      id\n      teams {\n        edges {\n          node {\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4a9025b1045a1760ef99690b1a6a6ee2";

export default node;
